import request from '@/utils/request'

let Platform_activityApi = {

  /*平台活动列表*/
  list(data) {
    return request._post('/shop/plus.platform_activity.Index/index', data);
},
/*添加平台活动*/
add(data) {
    return request._post('/shop/plus.platform_activity.Index/add', data);
},
/*修改平台活动*/
edit(data) {
    return request._post('/shop/plus.platform_activity.Index/edit', data);
},
/*删除平台活动*/
del(data) {
    return request._post('/shop/plus.platform_activity.Index/del', data);
},
bmNum(data) {
    return request._post('/shop/plus.platform_activity.Index/bmNum', data);
},
/*平台活动详情*/
detail(data) {
  return request._post('/shop/plus.platform_activity.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.platform_activity.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.platform_activity.Setting/getSetting', data, errorback);
    },
}
export default Platform_activityApi;



// WEBPACK FOOTER //
// ./src/api/platform_activity.js